import { locations, propertyTypes, conditions } from "../../estimationData";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatApiError = (detail) => {
  if (detail == null) return "Une erreur est survenue. Merci de réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
};

export const STATUSES = [
  { value: "new", label: "Nouveau", cls: "bg-[#B08D57]/15 text-[#8a6a35]" },
  { value: "in_progress", label: "En cours", cls: "bg-blue-100 text-blue-800" },
  { value: "done", label: "Traité", cls: "bg-emerald-100 text-emerald-800" },
];

const labelOf = (list, v) => list.find((x) => x.value === v)?.label || v;
export const locLabel = (v) => labelOf(locations, v);
export const typeLabel = (v) => labelOf(propertyTypes, v);
export const condLabel = (v) => labelOf(conditions, v);

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short", timeZone: "Europe/Paris" });
